/* eslint no-trailing-spaces: 0 */

const messages = {
  'params': {
    'label': '日本語'
  },
  'service': {
    'flow-and-time': '流量と時間',
    'ro-membrane': 'RO膜性能',
    'temperature': '温度検知',
    'leakage': '漏水検知',
    'pressure': '圧力値',
    'co2': 'CO2ガス残量'
  },
  'service-short': {
    'flow-and-time': '流量',
    'ro-membrane': 'RO',
    'temperature': '温度',
    'leakage': '漏水',
    'pressure': '圧力',
    'co2': 'CO2'
  },
  'sensor': {
    'flow': '流量センサー',
    'tds': 'TDSセンサー',
    'temperature': '温度センサー',
    'leakage': '漏水センサー',
    'pressure': '圧力センサー'
  },
  'user-params': {
    username: 'ユーザー名',
    email: 'メールアドレス',
    password: 'パスワード',
    password_reinput: 'パスワード (再入力)',
    password_reinput_differs: 'パスワードとパスワード(再入力)が異なります。',
    role: 'ロール'
  },
  'role': {
    'administrator': 'Administrator',
    'manager': 'Manager',
    'staff': 'Staff'
  },
  'btn': {
    'add': '追加',
    'edit': '編集',
    'cancel': 'キャンセル',
    'update': '更新',
    'save': '保存',
    'ok': 'OK',
    'delete': '削除',
    'resend': '再送'
  },
  'validate': {
    'phone-format': '数字のみ有効です',
    'phone-length': '128文字までです',
    'select': '選択してください',
    'vali-required': '必須項目です'
  },
  cognitoError: {
    UserNotFoundException: 'ユーザー名が見つかりません。',
    UsernameExistsException: '既に存在するユーザーです。',
    UserNotConfirmedException: 'ユーザー登録がまだ完了していません。',
    NotAuthorizedException: 'ユーザー名、パスワードのいずれかが不正です。',
    LimitExceededException:
      'リクエスト回数がシステムの上限回数を超えました。一定時間をおいて、再度リクエストを' +
      '実施してください。',
    CodeMismatchException:
      'システムによって発行された検証コードと一致しません。正しい検証コードを入力してください。',
    InvalidParameterException: '不正な入力値が指定されました。',
    UnknownError: '本サービスにて未知のエラーを検知しました。'
  },
  signup: {
    signup: '新規ユーザー登録',
    register: '新規ユーザー登録',
    btn_check_email: 'メールをご確認ください',
    buy_iotizr: 'IoTIZR購入のご相談',
    signupConfirmDialogText: 'この内容でユーザー登録しますか?',
    signupSuccessDialogText: 
      '新規ユーザー登録を受け付けました。ご指定のメールアドレスに no-reply@harps4.com より' + 
      'メールを送信いたします。登録を完了するためメール中のURLへのリンクのクリックを' +
      'お願いします。',
    agreement_msg: 
      'HARPSをはじめてご利用になる方(注)は、上記のフォームに任意のユーザーネーム' +
      '（４文字以上20文字以内のアルファベット、数字又は一部記号(.,-,_,@)の組みあわせ）' +
      'と任意のパスワードを入力し「ユーザー登録」ボタンをクリックしてください。' +
      '「ユーザー登録」を押すことにより、' + 
      '<a href="http://www.aplix.co.jp/legal/terms_harps.php">HARPS利用規約</a>、' +
      '<a href="http://www.aplix.co.jp/privacypolicy/privacypolicy_iot.php">IoTソリューションに関する個人情報保護方針</a>' +
      'に同意したものとみなします。利用者が日本に居住していない場合は、' +
      '<a href="http://www.aplix.co.jp/en/legal/terms_harps.php">HARPS Terms of Service</a>' +
      'に同意したものとみなします。<br>' +
      '<br>' +
      '（注）既存のHARPS組織にユーザーアカウントを追加する場合は、管理者に紹介を依頼してください。'
  },
  'login': {
    'login': 'ログイン',
    'lost': 'パスワードをお忘れの方',
    'link_to_signup': 'ユーザー登録',
    'vali-username-blank': 'ユーザー名は必須です。',
    'vali-password-blank': 'パスワードを入力してください。',
    'next': '次へ',
    'incorrect': 'ユーザー名またはパスワードが間違っています。'
  },
  'resetpassword': {
    'title': 'パスワードの再設定',
    'detail': 'ご登録いただいたユーザー名を入力してください',
    'entercode': '認証コードの入力',
    'newpassword': '新しいパスワード',
    'codedetail': '"no-reply@verificationemail.com"から認証コードをお送りしました。メールをご確認の上、認証コードを入力してください',
    'resendcode': '認証コードの再送',
    'vali-code-blank': '認証コードは必須です。',
    'vali-pass-blank': 'パスワードは必須です。',
    'vali-pass-number': '数字と英小文字を含む必要があります。',
    'vali-pass-length': '8文字以上である必要があります。',
    'vali-pass-whitespace': '空白を含むパスワードは設定できません。',
    'confirm': '確認'
  },
  activate: {
    title: 'アクティベーション',
    detail: 'メールに記載されたUsernameとパスワードをご入力ください。パスワードの変更が必要ですので、ご希望の新しいパスワードもご記入ください',
    temp_password: '仮パスワード',
    newpassword: '新しいパスワード',
    passwordreinput: '新しいパスワード(再入力)',
    agreement: '同意',
    agreement_msg: 
      '本サービスは株式会社アプリックスの提供によるものです。本サービスの利用者は、HARPSユーザー利用規約( ' + 
      '<a href="http://www.aplix.co.jp/legal/terms_harpsusers.php" target="_blank">' + 
      'HARPSユーザー利用規約</a>, 及び' + 
      '<a href="http://www.aplix.co.jp/privacypolicy/privacypolicy_iot.php" target="_blank">' +
      'IoTソリューションに関する個人情報保護方針</a> )に同意したものとみなします。' +
      '日本に居住していない利用者の方は、' +
      '<a href="http://www.aplix.co.jp/en/legal/terms_harpsusers.php" target="_blank">' +
      'HARPS USERS Terms of Service</a> に同意したものとみなします。',
    agree: '同意します。',
    you_need_to_agree: '同意していただく必要があります',
    submit: '送信',
    complete: 'アクティベートが完了しました。'
  },
  'global-menu': {
    'dashboard': 'ホーム',
    'watersystem': 'モニタリング',
    'customer': '設置拠点の管理',
    'setting': '設定',
    'pc': 'P/C 管理'
  },
  'home': {
    'notification': '通知',
    'information': '{0}からのお知らせ',
    'mail-notification-top': 'メール通知が利用可能になりました。',
    'mail-notification-under': '<a href=\'{0}\'>こちら</a>から設定してください。',
    'quick-link': 'クイックリンク',
    'calendar': 'メンテナンスカレンダー',
    'quick-link-settings': 'クイックリンクの設定',
    'notification-alert': '警告値に達しました',
    'notification-warning': '注意値に達しました'
  },
  'watersystem': {
    'column-nexttime': '次の交換予測時期',
    'customer-name': '設置拠点名',
    'customer': '設置拠点',
    'organization-name': '所有組織',
    'device-name': 'デバイス名',
    'device': 'デバイス',
    'deviceinfo': 'デバイス情報',
    'filter-life-left': 'フィルター寿命',
    'filter': 'フィルター',
    'flow-rate': '流量',
    'flow': '流量',
    'history': '履歴',
    'list': 'リスト表示',
    'mapinfo': '位置情報',
    'name': '名前',
    'period-month': 'ヶ月',
    'purification-amount': '浄水量',
    'RoMembrane': 'RO膜除去率',
    'RoMembrane-short': 'RO膜除去率',
    'RoMembrane-good': '良好',
    'RoMembrane-caution': '注意',
    'RoMembrane-alert': '警告',
    'Pressure': '圧力センサー',
    'Pressure-short': '圧力センサー',
    'Pressure-good': '良好',
    'Pressure-caution': '注意',
    'Pressure-alert': '警告',
    'service': 'サービス',
    'status': 'ステータス',
    'delete-water-system': '{0}を削除します。\n履歴はすべて失われます。',
    'delete-water-system-with-iotizr': '登録済みのIoTIZRは引き続き通信を行いますが、データを読むことはできなくなります。\nIoTIZRからの通信を止めたい場合には、IoTIZRの電源を抜いていただくか、アプリから削除してください。',
    'delete-water-system-ask': '本当に削除しますか？',
    'error-delete': '削除できませんでした。',
    'succeed-delete': '削除しました。',
    'filter-reset': 'フィルターリセット',
    'please-select': 'デバイスを選択してください',
    'elapsed-time': '経過時間',
    'total-flow': '総流量',
    'customer-info': '設置拠点情報',
    'rest-flow': '残り浄水可能量',
    'filter-reset-title': '注意',
    'filter-reset-text': '本当にフィルターリセットを行いますか？',
    'filter-reset-do': '実行',
    'filter-reset-cancel': 'キャンセル',
    'threshold': 'しきい値',
    'notification-threshold': '通知しきい値',
    'about-flow-and-time': '流量と時間のしきい値について',
    'about-ro-membrane': 'RO膜性能のしきい値について',
    'about-temperature': '温度のしきい値について',
    'about-pressure': '圧力値のしきい値について',
    'custom': 'カスタム',
    'use-preset': 'プリセットを使う',
    'flow-life': '流量寿命',
    'time-life': '時間寿命',
    'alert': '警告値',
    'warning': '注意値',
    'use-flow': '使用フローセンサー',
    'need-sensor': '必要なセンサー',
    'about-flow-and-time-text': 'ある時間内に、パイプ・ホース内で水の流れた量を測定します。時間の経過、流量の増加により通知を送信します。',
    'about-ro-membrane-text': 'RO膜の入口/出口 2箇所に、不純物含有率を測定するTDSセンサーのプローブを設置し、そのRO膜の不純物除去率を算出します。不純物除去率の低下により通知を送信します。',
    'about-pressure-text': 'センサー設置箇所の圧力値を測定します。IoTIZRのポート数の限り複数設置することができます。指定した圧力を超えると通知を送信します。',
    'about-temperature-text': 'センサー設置箇所の温度を測定します。IoTIZRのポート数の限り複数設置することができます。温度の変化により通知を送信します。',
    'about-setting-flow-and-time-text': '流量([UNIT])、時間(ヶ月)それぞれに注意・警告の通知が出るしきい値を設定します。',
    'about-setting-ro-membrane-text': '不純物除去率(%)で注意値・警告値を設定します。',
    'about-setting-temperature-text': '温度で注意値・警告値を設定します。',
    'about-setting-pressure-text': '圧力値で注意値・警告値を設定します。',
    'about-threshold-setting': 'しきい値の設定について',
    'headline-press-alert': '圧力値が警告値より低下しています。',
    'headline-press-warning': '圧力値が注意値より低下しています。',
    'headline-press-normal': '現在、圧力値は全て正常です。',
    'headline-diff-press-alert': '圧力値が警告値を超えています。',
    'headline-diff-press-warning': '圧力値が注意値を超えています。',
    'headline-temperature-up-alert': '温度が警告値より上昇しています。',
    'headline-temperature-up-warning': '温度が注意値より上昇しています。',
    'headline-temperature-down-alert': '温度が警告値より低下しています。',
    'headline-temperature-down-warning': '温度が注意値より低下しています。',
    'now-pressure': '現在の圧力値',
    'vali-threshold-must': '必須項目です',
    'vali-threshold-num': '数値で入力してください',
    'vali-threshold-min': '計測可能温度より下回っています。',
    'vali-threshold-max': '計測可能温度より上回っています。',
    'vali-threshold-min-comm': '{0} 以上で入力してください。',
    'vali-threshold-max-comm': '{0} 以下で入力してください。',
    'vali-threshold-integer': '整数で入力してください',
    'vali-threshold-limit100': '100までの数値で入力してください',
    'vali-threshold-positive-integer': '0以上の数値で入力してください',
    'impurities-removal-rate': '不純物除去率',
    'entrance-impurity-content': '入口側の不純物含有率',
    'exit-impurity-content': '出口側の不純物含有率',
    'time-elapsed': '時間経過',
    'pressure': '圧力値',
    'setting-link-text1': '変更するには',
    'setting-link-text2': '設定',
    'setting-link-text3': 'の「通知しきい値」を編集してください',
    'vali-threshold-alert-less-than': '警告値より小さい数値を入力してください',
    'vali-threshold-greater-than-warning': '注意値より大きい数値を入力してください',
    'vali-threshold-warning-less-than': '注意値より小さい数値を入力してください',
    'vali-threshold-greater-than-alert': '警告値より大きい数値を入力してください',
    'last-update': '最終更新日',
    'past-pressure': '{0}の圧力値',
    'last-update-for-chart': '最終更新',
    'last-update-week-suffix-for-chart': '{0}の週',
    'last-impurities-removal-late': '現在の不純物除去率',
    'past-impurities-removal-late': '{0}の不純物除去率',
    'differential-pressure': '差圧',
    'about-differential-pressure-text': '2点の圧力値を測定し、圧力値の差分(絶対値)を算出します。差圧の増加により通知を送信します。',
    'about-setting-differential-pressure-text': '差圧(絶対値)で注意値・警告値を設定します。',
    'differential-pressure-need-sensor': '圧力センサー×2',
    'differential-pressure-value': '圧力値',
    'leakage-all-normal': '現在、異常はありません。',
    'return-to-normal': '正常復帰',
    'leakage-alert': '水漏れを検知',
    'detection-history': '漏水履歴',
    'no-water-leak-history': '漏水履歴はありません。',
    'headline-leakage-alert': '水漏れを検知しています。現地を確認してください。',
    'leakage-normal': '異常なし',
    'leakage': '漏水センサー',
    'leakage-short': '漏水センサー',
    'temperature-short': '温度センサー',
    'temperature-alert': '警告を検知しました。',
    'temperature-warning': '注意を検知しました。',
    'temperature-normal': '現在、異常はありません。',
    'temperature-min': '以上',
    'temperature-max': '以下',
    'temperature-increase': 'しきい値よりも高くなると通知',
    'temperature-decrease': 'しきい値よりも低くなると通知',
    'temperature-content': '温度',
    'temperature-select-label': '通知ルール',
    'now-temperature': '現在の温度',
    'past-temperature': '{0}の温度'
  },
  'chart': {
    'dataZoom-zoom': 'ズーム',
    'dataZoom-back': 'ズーム解除',
    'change-period': '時間間隔の変更',
    'button-reload': '更新',
    'graph-label-fromlastchange': '前回のフィルター交換時からの総浄水量',
    'graph-label-diff': '時間間隔あたりの浄水量',
    'graph-label-sum': '総浄水量',
    '15m': '15分ごとのグラフ',
    '1h': '1時間ごとのグラフ',
    '1d': '1日ごとのグラフ',
    '1w': '1週間ごとのグラフ',
    '1M': '1ヶ月ごとのグラフ',
    'auto-reload': '自動更新',
    'label-date': '日付',
    'label-time': '時刻',
    'button-date-jump': '移動',
    'button-date-recent': '最新',
    'button-ok': 'Ok',
    'button-cancel': 'キャンセル',
    'message-oldest': '指定した日時のデータを中心に表示できないため、一番古いデータから表示しております。',
    'message-latest': '指定した日時のデータを中心に表示できないため、最新のデータを表示しております。',
    'message-outbounds-oldest': '指定した日時のデータが存在しないため、一番古いデータから表示しております。',
    'message-outbounds-latest': '指定した日時のデータが存在しないため、最新のデータを表示しております。',
    'message-no-data': 'データがありません。'
  },
  'csv-download': {
    'button-csv-download': 'CSVダウンロード',
    'button-download': 'ダウンロード',
    'start-datetime': '開始日時',
    'end-datetime': '終了日時',
    'failed-download-no-data': 'データがないため、ダウンロードできませんでした。',
    'failed-create-zip-file-fatal': '致命的なエラーが発生したため、ダウンロードできませんでした。',
    'failed-create-zip-file-busy': 'サーバが混雑しています。後ほどお試しください。',
    'invalid-start-end-datetime': '開始日時が終了日時より後になっています。'
  },
  /* 英語統一のため使用しない 2019/01/17 R.Inoue
  'csv-header': {
    'datetime': '日時',
    'organization-name': '組織名',
    'location-name': '設置拠点名',
    'device-name': 'デバイス名',
    'flow-log-status': '流量計の状態',
    'flow-log-flow': '総浄水量({0})',
    'flow-log-flow-diff': '時間間隔あたりの浄水量({0})',
    'ro-rate-log-status': 'RO膜の状態',
    'ro-rate-log-rate': '不純物除去率(%)',
    'temperature-log-status': '{0}:温度センサの状態',
    'temperature-log-temperature': '{0}:温度({1})',
    'leakage-log-status': '{0}:漏水センサの状態',
    'water-pressure-log-status': '{0}:圧力センサの状態',
    'water-pressure-log-pressure': '{0}:圧力値({1})'
  },
  */
  'user': {
    'unselected': '所属組織を選択してください',
    'nodata': 'ユーザーがいません',
    'username': 'ユーザー名',
    'email': 'メールアドレス',
    'role': 'ユーザーレベル',
    'edit-setting': '設定を変更する'
  },
  'organizations': {
    'title': '組織 一覧',
    'button-add': '組織追加',
    'button-add-pc': 'P/Cアカウントの追加',
    'vali-create-limit': '制限されているため下位組織が作れません',
    'limit-settings': '組織作成制限',
    'no-limit': '無制限'
  },
  'device': {
    'name': 'デバイス名',
    'vali-device-name': 'デバイス名は必須項目です。'
  },
  'settings': {
    'title': '設定',
    'unit': '水量の単位',
    'timezone': 'タイムゾーン',
    'timezone-location': '設置箇所のタイムゾーン',
    'pressureUnit': '圧力の単位',
    'temperatureUnit': '温度の単位',
    'display-setting': '表示設定',
    'available-sensor': '使用センサー',
    'life-and-notification': '消耗品寿命と通知',
    'notification-presets': '通知タイミングプリセット',
    'notification-mail': 'メール通知',
    'organization-user': '組織とユーザー',
    'management-organization': '組織の管理',
    'user-management': 'ユーザーの管理',
    'user-invitation': 'ユーザー招待',
    'add-organization': '組織を追加する',
    'pc-management': 'P/Cの管理',
    'set-up': '更新'
  },
  'account': {
    'delete-organization': '組織を削除',
    'basic-information': '基本情報',
    'organization': '組織名',
    'parent-organization': '親組織',
    'description': '説明',
    'tel': '電話番号',
    'email': 'メールアドレス',
    'contact': '連絡先',
    'incharge': '担当者',
    'administrator': '管理者',
    'name': '名前（任意）',
    'username': '管理者 ユーザー名（必須）',
    'useremail': '管理者 メールアドレス（必須）',
    'company': '会社名',
    'address': '住所',
    'created': '登録日',
    'edit': '編集',
    'caution-title': '注意',
    'caution-org-remove-text': '本当に下記の組織を削除しますか？',
    'caution-user-remove-text': '本当に下記のユーザーを削除しますか？',
    'caution-location-remove-text': '本当に下記の設置拠点を削除しますか？',
    'delete': '削除',
    'cancel': 'キャンセル',
    'close': '閉じる',
    'create': '作成',
    'updated': '更新しました',
    'error-delete': '削除できませんでした。',
    'error-customer': 'まだ関連する設置拠点が残っています。',
    'error-user': 'まだ配下にユーザーが残っています。',
    'error-root': 'この組織はルートのため消せません',
    'error-system': 'まだ関連するシステムが残っています。',
    'header-title': '組織とユーザー',
    'header-org': '組織の管理',
    'header-user': 'ユーザーの管理',
    'header-invite': 'ユーザーを招待',
    'header-pc': 'P/Cの管理',
    'invite-btn': '招待メールを送信',
    'policy': '運用方針',
    'agree': '同意する',
    'csv-import': 'CSVインポート機能を追加予定です',
    'label-role': '権限',
    'label-parent': '親組織',
    'label-belongto': '所属組織',
    'label-organization': '組織情報',
    'label-account': 'アカウント情報',
    'label-username': '管理者 ユーザー名',
    'label-useremail': '管理者 メールアドレス',
    'success-dialog': '招待メールを送信しました',
    'fail-dialog': '招待メールを送信できません',
    'vali-username-must': 'ユーザー名は必須です',
    'vali-username-format': 'ユーザー名は英数字と一部の記号(. - _ @)のみです',
    'vali-username-char': 'ユーザー名は4-20文字です',
    'vali-email-must': 'メールアドレスは必須です',
    'vali-email-format': 'メールアドレスが有効ではありません',
    'vali-phone-format': '数字のみ有効です',
    'vali-phone-length': '128文字までです',
    'vali-role': '選択してください',
    'vali-org-select': '選択してください',
    'vali-org-name': '組織名は必須です',
    'vali-location-name': '設置拠点名は必須です',
    'fail-registration': '登録に失敗しました',
    'fail-username': '入力されたユーザー名は登録できません',
    'fail-master-name': '最上位組織のため変更できません',
    'fail-email-update': 'メールアドレスの更新に失敗しました。' +
    '送信されたメールがございましたら廃棄願います。',
    'can-edit-message': '権限と組織を編集できます。',
    'cant-edit-yourself': '自身の設定は編集できません。',
    'update-succeed': '更新しました。',
    'delete-succeed': '削除しました。',
    'function-limit': '現在のアカウントでは、一部機能はご利用いただけません。',
    'cant-delete-yourself': '自身を削除することはできません。',
    'cant-delete-admin-user': '最上位組織の管理者ユーザーは最低一人は必要です。',
    'delete-completed-myself': '自身のアカウントの削除が完了しました。',
    'already-account': '既に登録済みのアカウントです。画面を更新してください。'
  },
  'viewable-locations': {
    'header-viewable-locations': '閲覧対象設置拠点の設定',
    'button-add-viewable-locations': '閲覧対象設置拠点の設定',
    'label-permit-viewing-locations': '閲覧許可する設置拠点',
    'select-is-not-limited-viewer': '全設置拠点',
    'select-is-limited-viewer': '選択拠点のみ',
    'label-viewing-target-locations': '閲覧対象設置拠点',
    'hint-viewing-target-locations': '閲覧対象設置拠点を選択してください',
    'button-set': '設定',
    'button-cancel': 'キャンセル'
  },
  'customer': {
    'add': '設置拠点を追加',
    'latitude': '緯度',
    'longitude': '経度',
    'info': '基本情報',
    'situation': '利用状況',
    'active-device': '設置デバイス数',
    'others': 'その他',
    'geo-location': '緯度経度',
    'defined': '設定済み',
    'undefined': '未設定',
    'situation-title': 'サービス利用状況レポート',
    'print': '印刷',
    'target': '対象',
    'sum': '合計',
    'history': '履歴',
    'iotizr-situation': 'IoTIZR 稼働状況',
    'service-plan': 'ご利用プラン',
    'device-customer': 'デバイス名(設置拠点名)',
    'date': '日付',
    'name': '設置拠点の名称',
    'device': 'デバイス名',
    'organization': 'この設置拠点を管理する組織',
    'address': '住所',
    'tel': '電話番号',
    'open-map': '地図から緯度経度を取得',
    'close-map': '地図を閉じる',
    'content': '内容',
    'get-address': '住所取得',
    'search': '検索',
    'error-location': '緯度経度取得できませんでした。',
    'error-delete': '削除できませんでした。',
    'error-delete-connecting-device': 'HARPS Toolkit でこの設置拠点のIoTIZRを削除してからもう一度お試しください。',
    'success-delete': '削除しました。'
  },
  'notifications': {
    'header-title': '消耗品寿命と通知',
    'header-preset': '通知タイミングプリセット',
    'header-mail': 'メール通知',
    'title-mail': 'メール通知',
    'title-langage': '言語設定',
    'japanese': '日本語',
    'english': '英語',
    'enable': '受け取る',
    'disable': '受け取らない'
  },
  'profile': {
    'profile': 'プロフィール',
    'role': '権限',
    'organization': '所属組織',
    'email': 'メールアドレス',
    'new-email': '新しいメールアドレス',
    'change-email': 'メールアドレス変更',
    'change-password': 'パスワード変更',
    'old-password': '現在のパスワード',
    'new-password': '新しいパスワード',
    'confirm-new-password': '新しいパスワード（確認）',
    'cancel': 'キャンセル',
    'change': '変更',
    'submit': '確定',
    'confirm': '確認',
    'resend': '確認コード再送信',
    'continue': '確認',
    'confirmation-code': '確認コードを入力してください。',
    'confirmation-code-input': '確認コード',
    'change-password-error': '現在のパスワードが違います',
    'not-verified': '未検証',
    'verify': '検証',
    'verified': 'メールアドレスの検証が完了しました',
    'vali-blank-new-pass': '新しいパスワードを入力してください',
    'vali-blank-old-pass': '現在のパスワードを入力してください',
    'vali-blank-confirm-new-pass': '新しいパスワード(確認)を入力してください',
    'vali-format': '英数字を含む8文字以上で入力してください',
    'vali-length': '25文字までです',
    'vali-same-password': '新しいパスワードと同じパスワードを入力してください',
    'vali-empty-code': 'コードを入力してください',
    'vali-email-format': 'メールアドレスが有効ではありません',
    'vali-invalid-code': '確認コードが違います',
    'code-confirm-text1': '確認コードが記載されたメールを送信しました。',
    'code-confirm-text2': 'メールを確認してコードを入力してください。',
    'code-confirm-title': '確認コード入力',
    'code-confirm-input': '確認コード',
    'change-email-title': 'メールアドレス変更',
    'change-password-title': 'パスワード変更',
    'success-resend': '確認コードをお送りしました。メールをご確認の上、認証コードを入力してください\nしばらく待っても届かない場合は、時間をおいて再度お試しください',
    'fail-resend': '確認コードの送信に失敗しました',
    'fail-error': '時間をおいて再度お試しください',
    'changed-password': 'パスワードを変更しました'
  },
  'aplix-use-only': {
    'customer-category': '顧客カテゴリ',
    'customer-categories': {
      '1': '不明',
      '2': '試験用',
      '3': '国内顧客',
      '4': '海外顧客'
    },
    'btn': {
      'can-not-execute': '実行不可',
      'can-not-save': '保存不可',
      'can-not-delete': '削除不可'
    },
    'usage-report': {
      'pc-organization': 'P/C 組織',
      'button-csv-download': 'CSVダウンロード'
    }
  },
  'usage-report': {
    'organization-name': '組織名',
    'target-date': '対象年月',
    'date': '対象年月',
    'print': '印刷',
    'total-device-count': '全組織合計',
    'units': '台',
    'location-count-title': '組織/設置拠点内訳',
    'location-count-list': {
      'organization-name': '組織名',
      'location-name': '設置拠点名',
      'device-count': 'IoTIZR台数'
    },
    'device-count-title': '個別内訳',
    'device-count-list': {
      'organization-name': '組織名',
      'location-name': '設置拠点名',
      'filtration-system-name': '浄水システム名',
      'unique-id': 'IoTIZR ID'
    },
    'can-not-print-ios': 'iOSでは印刷をサポートしていません',
    'no-data-text': '使用状況は翌月2日ころに更新されます。',  
    'failed-display-no-data': 'データがないため、表示できませんでした。',
    'failed-download-no-data': 'データがないため、ダウンロードできませんでした。',
    'failed-create-zip-file-fatal': '致命的なエラーが発生したため、ダウンロードできませんでした。',
    'failed-create-zip-file-busy': 'サーバが混雑しています。後ほどお試しください。'
  }
}

module.exports = messages



// WEBPACK FOOTER //
// ./src/assets/aqua_harps4_com/translations/japanese.js